export const IconStarFilled = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="m12 17.912 4.85 2.916c.888.534 1.975-.256 1.741-1.255l-1.285-5.483 4.288-3.694c.784-.674.363-1.952-.666-2.033l-5.644-.476-2.209-5.181c-.397-.941-1.753-.941-2.15 0l-2.209 5.17-5.644.475c-1.029.082-1.45 1.36-.667 2.033l4.29 3.694-1.286 5.483c-.234 1 .853 1.79 1.741 1.255z" />
    </svg>
  );
};
